import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";

// LFSplan 商業版 - Firebase 配置
const firebaseConfig = {
  apiKey: "AIzaSyB3mCa0c9FtGMwndXtYO_mF-SoOeJAdf6s",
  authDomain: "lfsplan.firebaseapp.com",
  projectId: "lfsplan",
  storageBucket: "lfsplan.firebasestorage.app",
  messagingSenderId: "391625986085",
  appId: "1:391625986085:web:064abe75852f30cd5defcc",
  measurementId: "G-E1HWJL3J8G"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const functions = getFunctions(app);

// 設定全域逾時時間為 120,000 毫秒 (2 分鐘)
export const solveNesting = httpsCallable(functions, "solve_nesting_api", { timeout: 120000 });
export const generateSerial = httpsCallable(functions, "generate_serial_key", { timeout: 30000 });
export const redeemSerial = httpsCallable(functions, "redeem_serial_key", { timeout: 30000 });

// 登入功能實作
export const signInWithGoogle = () => signInWithPopup(auth, googleProvider);
export const logout = () => signOut(auth);
